import CryptoAES from 'crypto-js/aes'
import CryptoENC from 'crypto-js/enc-utf8';

const { apiUrl, userName, password, middlewareUrl, middlewareUserName, middlewarePassword } = window['runConfig'];

const DataAccess = {
  apiUrl: CryptoAES.decrypt(apiUrl, '1271').toString(CryptoENC),
  userName: CryptoAES.decrypt(userName, '1271').toString(CryptoENC),
  password: CryptoAES.decrypt(password, '1271').toString(CryptoENC),
  middlewareUrl: CryptoAES.decrypt(middlewareUrl, '1271').toString(CryptoENC),
  middlewareUserName: CryptoAES.decrypt(middlewareUserName, '1271').toString(CryptoENC),
  middlewarePassword: CryptoAES.decrypt(middlewarePassword, '1271').toString(CryptoENC)
}

export default DataAccess;
